(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osenu-black-friday"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('osenu-campaign')) {
    customElements.define('osenu-campaign', class extends HTMLElement {
      connectedCallback() { this.checkExpiry(); }
      disconnectedCallback() { clearTimeout(this.expiryTimer); }
      checkExpiry() {
        clearTimeout(this.expiryTimer);
        const remaining = Date.parse(this.dataset.endsAt) - Date.now();
        if (!Number.isFinite(remaining) || remaining <= 0) { this.remove(); return; }
        this.expiryTimer = setTimeout(() => this.checkExpiry(), Math.min(remaining, 2147483647));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osenu-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('osenu-footer')) {
    customElements.define('osenu-footer', class extends HTMLElement {
      connectedCallback() {
        this.media = matchMedia('(min-width: 990px)');
        this.sync = () => this.querySelectorAll('[data-footer-menu]').forEach(menu => { menu.open = this.media.matches; });
        this.sync();
        this.media.addEventListener('change', this.sync);
      }
      disconnectedCallback() { this.media?.removeEventListener('change', this.sync); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osenu-retail-campaign"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('osenu-retail-campaign')) {
    customElements.define('osenu-retail-campaign', class extends HTMLElement {
      connectedCallback() { this.checkExpiry(); }
      disconnectedCallback() { clearTimeout(this.expiryTimer); }
      checkExpiry() {
        clearTimeout(this.expiryTimer);
        if (this.dataset.active !== 'true') return;
        const remaining = Date.parse(this.dataset.endsAt) - Date.now();
        if (!Number.isFinite(remaining) || remaining <= 0) {
          this.querySelectorAll('[data-retail-swap]').forEach(element => { element.textContent = element.dataset.default; });
          this.querySelectorAll('[data-promo-only]').forEach(element => { element.hidden = true; });
          this.dataset.active = 'false';
          return;
        }
        this.expiryTimer = setTimeout(() => this.checkExpiry(), Math.min(remaining, 2147483647));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
